import React, { useState, useCallback, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeOverlayStatus } from "../../../state/actionCreators";
import DeletePopup from "./DeletePopup";
import RequestWebsite from "./RequestWebsite";
import AddEmail from "./AddEmail";
import ChangeEmailPwd from "./ChangeEmailPwd";
import MailClientSettings from "./MailClientSettings";
import EditTicket from "./EditTicket";
import AddPaymentMethod from "./AddPaymentMethod";
import ChangePaymentMethod from "./ChangePaymentMethod";

const PopupModal = React.forwardRef((props, ref) => {

    const [displayPopup, setDisplayPopup] = useState(false);
    const [action, setAction] = useState("");
    const [data, setData] = useState({});
    const [error, setError] = useState("");
    const dispatch = useDispatch();

    useImperativeHandle(ref, () => ({
        openPopup,
        closePopup,
    }));

    // Open popup
    const openPopup = useCallback(
        (action, popupData = {}) => {
            setDisplayPopup(true);
            setAction(action);
            setData(popupData);
            setError("");
            dispatch(changeOverlayStatus("true"));
        },
        [dispatch]
    );

    // Close popup
    const closePopup = useCallback(() => {
        setDisplayPopup(false);
        setAction("");
        setData({});
        setError("");
        dispatch(changeOverlayStatus("false"));
    }, [dispatch]);

    // Update error
    const updateError = useCallback((errMsg) => {
        setError(errMsg);
    }, []);

    const renderPopupContent = () => {
        const popupProps = {
            data,
            updateError,
            closePopup,
        };

        switch (action) {
            case "deleteWebsite":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="website"
                        updateWebsite={props.updateWebsite}
                    />
                );
            case "deleteSubscription":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="subscription"
                        updateSubscription={props.updateSubscription}
                    />
                );
            case "deleteBackup":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="backupDelete"
                        deleteBackup={props.deleteBackup}
                    />
                );
            case "restoreBackup":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="backupRestore"
                        restoreBackup={props.restoreBackup}
                    />
                );
            
            case "deleteDomain":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="domainDelete"
                        deleteDomain={props.deleteDomain}
                    />
                );
            
            case "deleteEmail":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="emailDelete"
                        updateEmails={props.updateEmails}
                    />
                );

            case "requestWebsite":
                return (
                    <RequestWebsite
                        {...popupProps}
                    />
                );

            case "addEmail":
                return (
                    <AddEmail
                        {...popupProps}
                        updateEmails={props.updateEmails}
                    />
                );
            
            case "changeEmailPassword":
                return (
                    <ChangeEmailPwd
                        {...popupProps}
                    />
                );

            case "mailClientSettings":
                return (
                    <MailClientSettings
                        {...popupProps}
                    />
                );

            case "addTicket": 
                return (
                    <EditTicket
                        type="add"
                        {...popupProps}
                        addTicket={props.addTicket}
                    />
                );

            case "editTicket": 
                return (
                    <EditTicket
                        type="update"
                        {...popupProps}
                        updateTicket={props.updateTicket}
                    />
                );

            case "deleteTicket":
                return (
                    <DeletePopup
                        {...popupProps}
                        type="ticket"
                        deleteTicket={props.deleteTicket}
                    />
                );

            case "addPaymentMethod":
                return (
                    <AddPaymentMethod
                        {...popupProps}
                    />
                )

            case "changePaymentMethod":
                return (
                    <ChangePaymentMethod
                        {...popupProps}
                        updateSubscription={props.updateSubscription}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <div
            className={`mjs-popup ${
                displayPopup ? "fade-in" : "mjs-hidden"
            }`}
        >
            <div className="mjs-popup-inner">
                <span className="mjs-popup-close" onClick={closePopup}>
                    <i className="fa-solid fa-xmark"></i>
                </span>

                {renderPopupContent()}

                {error && <div className="mjs-error">{error}</div>}
            </div>
        </div>
    );
});

export default PopupModal;
